
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { useQueryRankingElementActionsConfig } from '../../composables/use-query-ranking-element-actions-config'
import { ExplainUtils } from '../../utils/explain.utils'
import { UiTooltip } from '../keen-ui'
import { DefaultImage } from '../shared'
import CopyToClipboard from '../shared/copy-to-clipboard.component.vue'
import { EpbBadge } from '../shared/epb-badge'
import { EpbButton } from '../shared/epb-button'

export default defineComponent({
  name: 'EpbExplainAsideResultCard',
  components: {
    CopyToClipboard,
    DefaultImage,
    EpbBadge,
    EpbButton,
    UiTooltip,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    collapsed: {
      type: Boolean,
      required: false,
    },
  },
  setup(props) {
    const queryRanking = useQueryRankingElementActionsConfig()

    const queryRankingAction = ExplainUtils.getQueryRankingConfigActionFromResult(props.result)
    const queryRankingConfig = queryRankingAction
      ? queryRanking.getActionConfig(queryRankingAction)
      : null

    return {
      baseClass: 'epb-explain-aside-result-card',
      queryRankingConfig,
    }
  },
})
